<template>
    <ToolButton :Editor="Editor" KnownIcon="ListUnordered" @ToolClick="Editor.chain().focus().toggleBulletList().run()">
        :class="{ 'toggled': Editor.isActive('bulletList') }"
    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>